import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _CHECK_USER_LOGIN = async (searchData = false) => {
  let url = ServiceUrl.LOGIN;
  return callApi(url, "post", searchData && searchData);
};
